var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.667 9.999A8.326 8.326 0 0010 18.332a8.326 8.326 0 008.333-8.333A8.326 8.326 0 0010 1.665 8.326 8.326 0 001.667 10zm11.325-4.167l1.175 1.175-2.992 2.992 2.992 2.991-1.175 1.175L10 11.174l-2.992 2.991-1.175-1.175L8.825 10 5.833 7.007l1.175-1.175L10 8.824l2.992-2.992z",
    fill: "currentColor"
  })));
}
export default SvgCloseCircle;